"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var react_web_components_1 = require("@nimles/react-web-components");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var Link_1 = require("./Link");

var ProductGroupsLabel = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  height: 48px;\n  padding: 0 8px;\n\n  @media (min-width: ", "px) {\n    padding: 0 32px;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  height: 48px;\n  padding: 0 8px;\n\n  @media (min-width: ", "px) {\n    padding: 0 32px;\n  }\n"])), function (props) {
  return props.theme.thresholds.sm;
});
var ProductGroupsIcon = styled_1.default(react_fontawesome_1.FontAwesomeIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 20px;\n"], ["\n  font-size: 20px;\n"])));
var Menu = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: #fff;\n  border: 1px solid lightgrey;\n"], ["\n  background: #fff;\n  border: 1px solid lightgrey;\n"])));

var toTree = function toTree(productGroups, parent) {
  return productGroups.filter(function (pg) {
    return parent ? pg.parentId === parent.id : !pg.parentId;
  }).map(function (pg) {
    return __assign(__assign({}, pg), {
      children: toTree(productGroups, pg)
    });
  });
};

exports.ProductGroupsMenu = function () {
  var _a = react_1.useState(),
      productGroup = _a[0],
      setProductGroup = _a[1];

  var productGroups = react_redux_1.useSelector(function (_a) {
    var publicProductGroups = _a.publicProductGroups;
    return publicProductGroups.values;
  });
  var filteredProductGroups = toTree(productGroups);
  return react_1.default.createElement(react_web_components_1.DropdownMenu, {
    align: "left",
    menu: function menu() {
      var _a, _b;

      return react_1.default.createElement(Menu, null, react_1.default.createElement(react_web_components_1.Row, null, react_1.default.createElement(react_web_components_1.Column, null, react_1.default.createElement(react_web_components_1.List, null, filteredProductGroups && filteredProductGroups.map(function (pg) {
        var name = pg.name,
            uniqueName = pg.uniqueName;
        return react_1.default.createElement(react_web_components_1.ListItem, {
          active: pg === productGroup,
          key: uniqueName,
          onClick: function onClick() {
            return Link_1.navigate("/" + uniqueName);
          },
          onMouseOver: function onMouseOver() {
            return setProductGroup(pg);
          }
        }, name);
      }))), ((_a = productGroup) === null || _a === void 0 ? void 0 : _a.children) ? react_1.default.createElement(react_web_components_1.Column, {
        style: {
          borderLeft: '1px solid #ddd'
        },
        flex: true
      }, react_1.default.createElement(react_web_components_1.List, null, (_b = productGroup) === null || _b === void 0 ? void 0 : _b.children.map(function (pg) {
        var name = pg.name,
            uniqueName = pg.uniqueName;
        return react_1.default.createElement(react_web_components_1.ListItem, {
          key: uniqueName,
          onClick: function onClick() {
            return Link_1.navigate("/" + uniqueName);
          }
        }, name);
      }))) : null));
    }
  }, react_1.default.createElement(ProductGroupsLabel, null, react_1.default.createElement(ProductGroupsIcon, {
    icon: free_solid_svg_icons_1.faTh
  })));
};

var templateObject_1, templateObject_2, templateObject_3;